
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { TypeAheadViewModel } from "@tylertech/tyler-api-types";

/**
 * RequestedByLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class RequestedByLookupService {
    private readonly $apiService = inject(ApiService);
    
    Search(criteria: string): Promise<TypeAheadViewModel[]> {
        return this.$apiService.sendAuth("IRequestedByLookupService/Search", criteria);
    }
}
